/**
 * Video practice (P5) — the words the learner consents to.
 *
 * Kept as data so the consent screen, the results screen and the guard tests
 * read ONE statement of what is and is not analysed. Every claim here must be
 * true of the code: the camera stays in the browser (no recording, no upload,
 * no frames sent to the conversation model), and the visual measurements are
 * not available until LevelUp Media provides them.
 */

/** What video practice looks at: observable behaviour a coach could point at. */
export const VIDEO_ANALYSED: readonly string[] = Object.freeze([
  'Whether you are on camera (in frame)',
  'How much of the time you are looking toward the camera',
  'How often you use visible hand gestures',
  'How long you spoke',
]);

/** What it never does — stated plainly, because a camera invites the assumption. */
export const VIDEO_NOT_ANALYSED: readonly string[] = Object.freeze([
  'Your emotions, mood or how you feel',
  'Whether you seem honest, trustworthy or confident as a person',
  'Your personality or state of mind',
  'Your appearance or attractiveness',
  'Your age, gender, race, disability or any other personal characteristic',
  'Whether you are suitable for a job',
]);

export const VIDEO_RETENTION_NOTICE =
  'Your video is not recorded or stored. The camera preview stays in your browser and is not sent to the conversation partner, who cannot see you.';

export const VIDEO_AVAILABILITY_NOTICE =
  'The on-camera measurements are not available yet: they will appear as “Not measured — awaiting LevelUp Media” until LevelUp Media provides them. Nothing is estimated in the meantime.';

export const VIDEO_CONSENT_LABEL = 'I understand what video practice looks at, and I want to turn on my camera.';

/** The label results show for any video value that was not measured. */
export const VIDEO_UNAVAILABLE_LABEL = 'Not measured — awaiting LevelUp Media';
